import { CART_PRODUCT_TYPES } from "../../constants/index.js";
var HOTEL = CART_PRODUCT_TYPES.HOTEL,
  FLIGHT = CART_PRODUCT_TYPES.FLIGHT,
  LOYALTY = CART_PRODUCT_TYPES.LOYALTY,
  WALLET = CART_PRODUCT_TYPES.WALLET,
  QITAF = CART_PRODUCT_TYPES.QITAF,
  RULE = CART_PRODUCT_TYPES.RULE,
  COUPON = CART_PRODUCT_TYPES.COUPON,
  ACCOMMODATION = CART_PRODUCT_TYPES.ACCOMMODATION,
  GIFTCARD = CART_PRODUCT_TYPES.GIFTCARD,
  ACTIVITIES = CART_PRODUCT_TYPES.ACTIVITIES,
  MOKAFAA = CART_PRODUCT_TYPES.MOKAFAA;

/**
 * isValidProduct
 * @description this util function checks whether a given cart product is valid or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isValidProduct = function isValidProduct(p) {
  return p.valid;
};

/**
 * isHotelProduct
 * @description this util function checks whether a given cart product is hotel or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isHotelProduct = function isHotelProduct(p) {
  return p.type === HOTEL;
};

/**
 * isFlightProduct
 * @description this util function checks whether a given cart product is flight or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isFlightProduct = function isFlightProduct(p) {
  return p.type === FLIGHT;
};

/**
 * isCartType
 * @description this util function return cart product type
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isCartType = function isCartType(p) {
  return [ACTIVITIES, HOTEL, FLIGHT, ACCOMMODATION, GIFTCARD].includes(p.type);
};

/**
 * isC2CProduct
 * @description this util function checks whether a given cart product is chalet or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isAccommodation = function isAccommodation(p) {
  return p.type === ACCOMMODATION;
};

/**
 * isGiftCardProduct
 * @description this util function checks whether a given cart product is giftCard or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isGiftCard = function isGiftCard(p) {
  return p.type === GIFTCARD;
};

/**
 * isLoyaltyLineItem
 * @description this util function checks whether a given cart product is loyalty or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isLoyaltyLineItem = function isLoyaltyLineItem(p) {
  return p.type === LOYALTY;
};

/**
 * isLoyaltyProduct
 * @description this util function checks whether a given cart product is loyalty or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isLoyaltyProduct = function isLoyaltyProduct(p) {
  return p.type === LOYALTY;
};

/**
 * isWalletProduct
 * @description this util function checks whether a given cart product is wallet or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isWalletProduct = function isWalletProduct(p) {
  return p.type === LOYALTY && p.category === WALLET;
};

/**
 * isQitafProduct
 * @description this util function checks whether a given cart product is qitaf or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isQitafProduct = function isQitafProduct(p) {
  return p.type === LOYALTY && p.category === QITAF;
};

/**
 * isMokafaaProduct
 * @description this util function checks whether a given cart product is Mokafaa or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isMokafaaProduct = function isMokafaaProduct(p) {
  return p.type === LOYALTY && p.category === MOKAFAA;
};

/**
 * isCouponProduct
 * @description this util function checks whether a given cart product is coupon or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isCouponProduct = function isCouponProduct(p) {
  return p.type === RULE && p.category === COUPON;
};

/**
 * isRuleProduct
 * @description this util function checks whether a given cart product is rule or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isRuleProduct = function isRuleProduct(p) {
  return p.type === RULE && p.category === RULE;
};

/**
 * isRuleLineItem
 * @description this util function checks whether a given cart product is rule or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isRuleLineItem = function isRuleLineItem(p) {
  return p.type === RULE;
}; // && p.category === RULE;

/**
 * isRuleLineItem
 * @description this util function checks whether a given cart product is rule or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isCouponLineItem = function isCouponLineItem(p) {
  return p.type === RULE && p.category === COUPON;
}; // && p.category === RULE;

/**
 * isActivityProduct
 * @description this util function checks whether a given cart product is flight or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
export var isActivityProduct = function isActivityProduct(p) {
  return p.type === ACTIVITIES;
};
export var isActivityLineItem = function isActivityLineItem(p) {
  return p.type === ACTIVITIES;
};
export function getCartPredicate(productType) {
  var _cartPredicateMap;
  if (productType === void 0) {
    productType = '';
  }
  if (!productType) return function () {
    return false;
  };
  var cartPredicateMap = (_cartPredicateMap = {}, _cartPredicateMap[HOTEL] = isHotelProduct, _cartPredicateMap[FLIGHT] = isFlightProduct, _cartPredicateMap[ACCOMMODATION] = isAccommodation, _cartPredicateMap[ACTIVITIES] = isActivityProduct, _cartPredicateMap);
  return cartPredicateMap[productType];
}